import 'core-js';
import 'rxjs';

import Radium from 'radium';
import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { createBrowserHistory } from 'history';
import './assets/styles/reset.css';
import '@hyperfish/fishfood/lib/styles.css';
import './assets/styles/branding.css';

import { FishFail } from './components/FishFail';
import configureStore from './configureStore';
import { State } from './models';
import Root from './root';

export const baseUrl = document.getElementsByTagName('base')[0].getAttribute('href');
// history 5 has no basename: the router strips it from the location, so direct history calls need the full path.
export const history = createBrowserHistory();

const dest = document.getElementById('root');
const initialState = (window as any).intialReduxState as State;
const store = configureStore(initialState);

// Legacy root on purpose: @hyperfish/fishfood 1.x and react-select 1 inside it predate React 18, and createRoot would
// also switch on automatic batching for the class components' async setState calls. Revisit with fishfood 3.
// eslint-disable-next-line react/no-deprecated
ReactDOM.render(
  <FishFail>
    <Radium.StyleRoot>
      <Provider store={store}>
        <Root history={history} basename={baseUrl} />
      </Provider>
    </Radium.StyleRoot>
  </FishFail>,
  dest,
);

// enable debugger
if (process.env.NODE_ENV !== 'production') {
  window['react'] = React;
}
